/* eslint-env browser, jquery */
import page from 'modules/ab-page-js';
import domify from 'domify';
import container from 'modules/section-content';
import splash from './pages/ss-oq-page.pug';
import metadata from './metadata.json';
import ssOqPapers from './data/ssOqPapers.json';

export default function register() {
  page('/legal/ss-oq-collection-guidelines', render);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    ssOqPapers,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);

  next();
}



// WEBPACK FOOTER //
// ./src/pages/legals/ss-oq-collection-guidelines/ssOq.js